import { ApolloClient, NormalizedCacheObject } from 'apollo-boost'

import { ClientBehaviours } from '../../utils'
import { ComponentWidgets as QUERY } from '../../../graphql/Query/ComponentWidgets/ComponentWidgets'
import { Country, Currency, Widget } from '../../../generated/graphql'

export const mockComponentWidgets = [
  {
    id: '232423',
    itemCTAAlign: 'centre',
    title: 'Shop by category',
    itemTitleAlign: 'left',
    itemOneTitle: 'HAIRCARE',
    itemOneCTA: 'Shop Now',
    itemOneLink: '/health-beauty/hair/view-all-haircare.list',
    itemOneImage:
      'https://s1.thcdn.com/widgets/95-en/54/original-0121-STDCRE-20084-WC-LF-February-Batching-Part-Two-Shot-10-507_x_417-103654.jpg',
    altItemOne: '',
    itemTwoTitle: 'MAKEUP',
    itemTwoCTA: 'Shop Now',
    itemTwoLink: 'https://www.lookfantastic.com/health-beauty/make-up.list',
    itemTwoImage:
      'https://s1.thcdn.com/widgets/95-en/04/original-0121-STDCRE-20084-WC-LF-February-Batching-Part-Two-Shot-12-507_x_417-103704.jpg',
    altItemTwo: '',
    itemThreeTitle: 'FRAGRANCE',
    itemThreeCTA: 'Shop Now',
    itemThreeLink: 'https://www.lookfantastic.com/health-beauty/fragrance.list',
    itemThreeImage:
      'https://s1.thcdn.com/widgets/95-en/32/original-0120-STDCRE-29936-WC-LF-February-Product-Shoot-Batching-Shot01-507_x_417-103732.jpg',
    altItemThree: '',
    itemFourTitle: 'WELLNESS',
    itemFourCTA: 'Shop Now',
    itemFourLink: '/health-beauty/body/wellness/view-all.list',
    itemFourImage:
      'https://s1.thcdn.com/widgets/95-en/50/original-1231-STDCRE-28430-WC-LF-January-Product-Photography-Batching-Part-1-Shot-29-507_x_417-103950.jpg',
    altItemFour: '',
    itemFiveTitle: 'SKINCARE',
    itemFiveCTA: 'Shop Now',
    itemFiveLink: 'https://www.lookfantastic.com/health-beauty/face.list',
    itemFiveImage:
      'https://s1.thcdn.com/widgets/95-en/10/original-0121-STDCRE-20084-WC-LF-February-Batching-Part-Two-Shot-06-507_x_417-104110.jpg',
    altItemFive: '',
    itemSixTitle: 'TOOLS',
    itemSixCTA: 'Shop Now',
    itemSixLink: '/at-home-tools.list',
    itemSixImage:
      'https://s1.thcdn.com/widgets/95-en/03/original-1230-STDCRE-28430-LF-LGM-507_x_417-104003.jpg',
    altItemSix: '',
    __typename: 'GlobalSixItemCategories',
  },
  {
    id: '1419943',
    imageAltText: 'Model looking at benefits of subscribing',
    imageMedium:
      'https://s1.thcdn.com/widgets/95-en/09/LF-Q1-Feb-BANNER-10-286_x_416-030909.jpg',
    emailReEngagementTitleText:
      'Sign up today and enjoy 15% off your first order, plus...',
    emailReEngagementBulletText3: 'Exclusive offers',
    emailReEngagementBulletText2: 'Early access to sales',
    emailReEngagementBulletText1: 'Exclusive brand launches',
    imageSmall:
      'https://s1.thcdn.com/widgets/95-en/23/LF-Q1-Feb-BANNER-1-290_x_130-031123.jpg',
    imageLarge:
      'https://s1.thcdn.com/widgets/95-en/06/LF-Q1-Feb-BANNER-10-286_x_416-030906.jpg',
    emailReEngagementOptInDiscount: '',
    __typename: 'EmailReEngagementModal',
  },
]

export interface ComponentWidgetsData {
  componentWidgets: Widget[]
}

export interface ComponentWidgetsVariables {
  name: string
  currency: Currency
  shippingDestination: Country
}

export enum ComponentName {
  BASKET = 'basket',
  GLOBAL = 'global',
  WISHLIST = 'wishlist',
  ACCOUNT = 'account',
}

export const ComponentWidgets = (
  client: ApolloClient<NormalizedCacheObject>,
  { behaviours }: { behaviours: ClientBehaviours },
) => async (_: any, args) => {
  if (behaviours.override) {
    return mockComponentWidgets
  }

  const { data } = await client.query<ComponentWidgetsData>({
    query: QUERY,
    variables: args,
  })

  return data.componentWidgets
}
